import React, { useEffect } from 'react';
import { Modal, MessageBoxFunctionalLayout } from '@wix/design-system';

export function CheckAppStatusModal({
  checkStatusUrl,
  closeModal,
}: {
  checkStatusUrl: string;
  closeModal(): void;
}) {
  function handleMessage(msg) {
    if (
      msg.data.type === 'APP_INSTALLATION_FINISHED' ||
      msg.data.type === 'CONSENT_USER_CANCELED' ||
      msg.data.type === 'FINISH_INSTALLATION_EMBEDDED'
    ) {
      closeModal();
    }
  }
  useEffect(() => {
    window.addEventListener('message', (msg) => {
      handleMessage(msg);
    });

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <Modal isOpen={true}>
      <MessageBoxFunctionalLayout
        title=""
        theme="blue"
        width="800px"
        noBodyPadding
        hideFooter
        onClose={closeModal}
      >
        <iframe
          src={checkStatusUrl}
          width="100%"
          height="700px"
          frameBorder="0"
        />
      </MessageBoxFunctionalLayout>
    </Modal>
  );
}
